<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="INSTALACIÓN ELÉCTRICA" />

      <b-row align-h="center">
        <b-col lg="5" cols="10">
          <div class="d-flex flex-column justify-content-center align-items-center mb-1">
            <b-img :src="electricalImg" alt="electrical" style="width: 90%;" />
            <div
              class="d-flex fs-20 justify-content-center align-items-center my-2"
              style="border: 2px solid #f5c430; border-radius: 4px; padding: 0.2em 8px;"
            >
              <font-awesome-icon :icon="['far', 'exclamation-triangle']" fixed-width />
              <p class="mb-0 mx-2">Suministro eléctrico de la instalación</p>
              <input
                type="text"
                disabled
                class="fs-23 font-weight-bold text-center"
                value="120 VAC"
                style="width: 95px; background-color: #fff; border: none; border-radius: 5px;"
              />
            </div>
          </div>
          <b-row class="mb-2">
            <b-form-group label-class="configurator-label" class="w-100 mb-0">
              <template #label>
                <BlankIcon :field="form.panel_distance" />
                <span>Distancia del panel</span>
                <p class="text-muted mb-1 ml-2" style="font-size: 17px;">Desde la posición del andén hasta el panel eléctrico más cercano</p>
              </template>
              <b-select v-model="form.panel_distance" :options="panelDistanceOptions">
                <template #first>
                  <b-select-option v-show="!form.panel_distance" :value="null">
                    -- seleccionar --
                  </b-select-option>
                </template>
              </b-select>
            </b-form-group>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters} from 'vuex'

import BlankIcon from '../BlankIcon'
import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import ElectricalImage from 'images/andenes/electrico.webp'

export default {
  name: 'Electrical',
  components: { ConfiguratorStepTitle, BlankIcon },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      form: {
        panel_distance: ''
      },
      panelDistanceOptions: [
        { text: '1-5 metros', value: '1-5m' },
        { text: '6-10 metros', value: '6-10m' },
        { text: '11-15 metros', value: '11-15m' },
        { text: '+16 metros', value: '+16m' }
      ],
      electricalImg: ElectricalImage
    }
  },
  mounted () {
    this.form.panel_distance = this.anden.panel_distance
  },
  computed: {
    ...mapState({ anden: state => state.configurator.configurable }),
    ...mapGetters(['configuratorStepNumber'])
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true
      const result = await this.updateConfigurable(this.form)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.anden[key])
    }
  }
}
</script>
